export const GET_CUSTOMERS_LOCATIONS_REQUEST = 'GET_CUSTOMERS_LOCATIONS_REQUEST';
export const GET_CUSTOMERS_LOCATIONS_SUCCESS = 'GET_CUSTOMERS_LOCATIONS_SUCCESS';
export const GET_CUSTOMERS_LOCATIONS_FAILURE = 'GET_CUSTOMERS_LOCATIONS_FAILURE';
